import React, {Component} from 'react';


import ForgotPasswordComponent from '../../ForgotPassword/components/ForgotPasswordComponent';
import LightBoxComponent from "../../lightbox/components/LightBoxComponent";
import AuthenticationService from '../../../../services/AuthenticationService';
import { withTranslation } from 'react-i18next';

import "../style/LoginStyle.scss"

class LoginComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            email: "",
            password: "",
            showForgotPasswordModal: false,
        }
    }

    onChangeEmail(ev) {
        this.setState({
            email: ev.target.value
        })
    }

    onChangePassword(ev) {
        this.setState({
            password: ev.target.value
        })
    }

    authUser() {
        AuthenticationService.login(this.state).catch(ex => {
            if(ex.error === "invalid_grant") {
                this.setState({ showForgotPasswordModal: true });
            }
        });
    }

    closeForgotPasswordModal(){
        this.setState({
            showForgotPassword: false,
            showForgotPasswordModal:false
        });

    }

    closeModal(){
        this.setState({
            showForgotPasswordModal: false
        })
    }



    render() {
        return (
            <div>
                <div id="contentLogin">
                    <h2>{this.props.t('WELCOME BACK')}!</h2>
                    <form>
                        <div className="formItem">
                            <input placeholder="Email" type="text" id="email" value={this.state.email} onChange={(ev) => this.onChangeEmail(ev)}/>
                        </div>
                        <div className="formItem">
                            <input placeholder={this.props.t('Password')} type="password" id="password" value={this.state.password} onChange={(ev) => this.onChangePassword(ev)} />
                        </div>

                        <div className="formItem textRight">
                            <div className="button" onClick={() => this.authUser()}>{this.props.t('Sign In')}</div>
                        </div>
                    </form>
                    <div className="not-registered-box">
                        <span>{this.props.t('Not registered yet')}?</span>
                        <div className="button" onClick={() => this.props.OpenRegister()}>{this.props.t('Register for BLANC')}</div>
                    </div>
                </div>
                <LightBoxComponent extraClass="forgot-password" isOpen={this.state.showForgotPasswordModal} handleClick={this.closeModal.bind(this)} handleEventClose={this.closeModal.bind(this)} >
                    <ForgotPasswordComponent
                    closeForgotPasswordModal={this.closeForgotPasswordModal.bind(this)}
                    />
                </LightBoxComponent>
            </div>
        );
    }
};

export default withTranslation()(LoginComponent);
